import React, { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { Box, Card, Text } from "rebass";
import { FieldProps } from "formik";
import { toastr } from "react-redux-toastr";

import { getFolders } from "../../../../store/modules/library/selectors";
import { getUser } from "../../../../store/modules/session/selectors";
import { ROOT_FOLDER } from "../../../../store/modules/library/constants";

import { Select } from "../../../forms/components/Select";

export const FolderInput: React.FC<FieldProps> = (
  {
    field,
    field: { name },
    form,
    form: { errors },
  }
) => {
  const user = useSelector(getUser);
  const folders = useSelector(getFolders);

  /* convert folders to option */
  const option = useMemo(() => Object.entries(folders)
    .filter(([, { isArchived }]) => !isArchived)
    .map(([id, { title }]) => ({
      label: title || id,
      value: user && id === ROOT_FOLDER ? user.uid : id,
    })), [user, folders]);
  /* get error for field */
  const hasError = useMemo(() => Boolean(errors[name]), [name, errors]);
  /* show toastr error if field has error */
  useEffect(() => {
    if (hasError) {
      toastr.error("Target folder", "Select target folder.");
    }
  }, [hasError]);

  return (
    <Card
      m="0 35px 25px"
      px="20px"
      py="9px"
      border="1px solid"
      borderColor={hasError ? "orange" : "transparent"}
      borderBottomColor={hasError ? "orange" : "sp-gray1"}
      borderRadius={hasError ? "4px" : 0}
      bg={hasError ? "orange-25" : "transparent"}
      css="display: flex; align-items: center; transition: all .4s;"
    >
      <Text
        width={1 / 2}
        color="zodiac"
        fontWeight={600}
      >
        target folder:
      </Text>

      <Box flex={1}>
        <Select
          field={field}
          form={form}
          options={option}
        />
      </Box>
    </Card>
  );
};
